import { toast } from 'sonner'

/**
 * Mostra una notifica toast utilizzando sonner.
 * Drop-in replacement per il vecchio window.growl.show({ severity, summary, detail }).
 *
 * @param {'success'|'error'|'warn'|'info'} severity - Tipo di notifica
 * @param {string} summary - Titolo della notifica
 * @param {string} [detail] - Descrizione aggiuntiva
 */
export const showToast = (severity, summary, detail) => {
  const description = detail || undefined
  const opts = { description }

  switch (severity) {
    case 'success':
      return toast.success(summary, opts)
    case 'error':
      return toast.error(summary, opts)
    case 'warn':
      return toast.warning(summary, opts)
    case 'info':
    default:
      return toast.info(summary, opts)
  }
}

/**
 * Backward-compatible shim: espone la stessa interfaccia di window.growl.show()
 * così i file ancora non migrati continuano a funzionare.
 */
export const growlCompat = {
  show: ({ severity, summary, detail }) => showToast(severity, summary, detail)
}
